__turbopack_context__.v({
  "quote": "QuoteCard-module__V74uUa__quote",
  "quote-card": "QuoteCard-module__V74uUa__quote-card",
  "quote-card__author": "QuoteCard-module__V74uUa__quote-card__author",
  "quote-card__text": "QuoteCard-module__V74uUa__quote-card__text",
});
